import React from "react";
import { Route, Routes } from "react-router-dom";
import { POSSyncLists, SyncHistoryDetails } from "./containers";
import { ProtectedRoute } from "../../shared";

export const POSSync = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<POSSyncLists />} />
        <Route>
          <Route path="/sync-details/:id" element={<SyncHistoryDetails />} />
        </Route>
      </Routes>
    </>
  );
};
